import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import Loader from "../../shared/loader";
import Pagination from "../../shared/pagination";
import Select from "react-select";
import DatePicker from "react-date-picker";

const Invoices = () => {
  const [invoiceData, setInvoiceData] = useState([]);
  const [partyData, setPartyData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [partyId, setPartyId] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [invoiceNo, setInvoiceNo] = useState("");
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [salesStatus, setSalesStatus] = useState("In Progress");
  const itemsPerPage = 30;

  const getParty = () => {
    axios.post(API_URL.PARTY_LIST, { is_seller: [0] }).then(
      (res) => {
        if (res.data && res.data.data && res.data.data.length > 0) {
          let pt = res.data.data.map((raw) => {
            return {
              label: raw.name + " - " + raw.contact_no,
              value: raw.id,
            };
          });
          setPartyData(pt);
        }
      },
      (error) => {
        toast.error("Failed to load parties", {
          autoClose: 3000,
        });
      }
    );
  };

  const getInvoices = (page = 1) => {
    setLoading(true);
    const params = {
      page: page,
      limit: itemsPerPage,
      status: salesStatus,
    };

    if (partyId) {
      params.party_id = partyId;
    }
    if (fromDate) {
      params.from_date = moment(fromDate).format("YYYY-MM-DD");
    }
    if (toDate) {
      params.to_date = moment(toDate).format("YYYY-MM-DD");
    }
    if (invoiceNo && invoiceNo.trim() !== "") {
      params.invoice_no = invoiceNo.trim();
    }

    axios.post(API_URL.INVOICE_LIST, params).then(
      (res) => {
        if (res.data.status === 1) {
          res.data.data.data.map(
            (item) => (item.date = moment(item.date).format("DD/MM/YYYY"))
          );
          setInvoiceData(res.data.data.data);
          const total = res.data.data.total || 0;
          setTotalPages(Math.ceil(total / itemsPerPage));
          setTotalCount(total);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,
        });
      }
    );
  };

  const deleteInvoice = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this Invoice",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.INVOICE_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              toast.success(row.invoice_no + " Delete Successfully", { autoClose: 3000 });
              getInvoices(currentPage); // reload current page
            } else {
              toast.error(res.data.data, { autoClose: 3000 });
            }
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", { autoClose: 3000 });
          }
        );
      }
    });
  };

  useEffect(() => {
    getParty();
    getInvoices(1);
    setIsInitialLoad(false);
  }, []);
  
  useEffect(() => {
    if (!isInitialLoad) {
      getInvoices(1);
    }
  }, [salesStatus]);

  useEffect(() => {
    if (!isInitialLoad) {
      setCurrentPage(1);
      getInvoices(1);
    }
  }, [partyId, invoiceNo, fromDate, toDate]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    getInvoices(page);
  };

  const handleFilterChange = (filterType, value) => {
    if (filterType === "party") {
      setPartyId(value ? value.value : null);
    } else if (filterType === "fromDate") {
      setFromDate(value);
    } else if (filterType === "toDate") {
      setToDate(value);
    } else if (filterType === "invoiceNo") {
      setInvoiceNo(value);
    }
  };

  const clearFilters = () => {
    setPartyId(null);
    setFromDate(null);
    setToDate(null);
    setInvoiceNo("");
    setCurrentPage(1);
  };

  return (
    <>
      <div className="row">
        <div className="col-md-6">
            <h1>Invoices <small className="me-2">({totalCount})</small></h1>
        </div>
        <div className="col-md-6">
          <div className="d-flex align-items-center justify-content-end">
            <Link to={"/sales/invoices/add"} className="btn btn-primary">
                <i className="fa fa-plus-circle me-2" aria-hidden="true"></i> Add Invoice
            </Link>
          </div>
        </div>
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-2 mb-3">
                  <div className="form-group">
                    <label>Invoice Number</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Invoice Number"
                      value={invoiceNo}
                      onChange={(e) => handleFilterChange("invoiceNo", e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-3 mb-3">
                  <div className="form-group">
                    <label>Party</label>
                    <Select
                      placeholder="Select Party"
                      value={partyData.find(pt => pt.value === partyId)}
                      options={partyData}
                      onChange={(e) => handleFilterChange("party", e)}
                      isClearable
                    />
                  </div>
                </div>
                <div className="col-md-2 mb-3">
                  <div className="form-group">
                    <label>From Date</label>
                    <DatePicker
                      format="dd/MM/y"
                      className="form-control"
                      onChange={(date) => handleFilterChange("fromDate", date)}
                      value={fromDate}
                    />
                  </div>
                </div>
                <div className="col-md-2 mb-3">
                  <div className="form-group">
                    <label>To Date</label>
                    <DatePicker
                      format="dd/MM/y"
                      className="form-control"
                      onChange={(date) => handleFilterChange("toDate", date)}
                      value={toDate}
                    />
                  </div>
                </div>
                <div className="col-md-3 mb-3">
                  <div className="form-group">
                    <label>&nbsp;</label>
                    <div>
                      {(partyId || fromDate || toDate || invoiceNo) && (
                        <button
                          type="button"
                          className="btn btn-danger"
                          onClick={clearFilters}
                        >
                          <i className="fa fa-times me-1"></i> Clear Filters
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-12 mt-3">
          <div className="btn-group mb-3">
            <button className={salesStatus === "In Progress" ? "btn btn-primary" : "btn btn-light"} style={{ border: "1px solid #000", fontWeight: "bold" }} onClick={() => setSalesStatus("In Progress")}>In Progress</button>
            <button className={salesStatus === "Completed" ? "btn btn-primary" : "btn btn-light"} style={{ border: "1px solid #000", fontWeight: "bold" }} onClick={() => setSalesStatus("Completed")}>Completed</button>
          </div>
          <div className="card">
            <div className="card-body p-0">
              {loading && <Loader></Loader>}
              {!loading && (
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>No.</th>
                        <th>Invoice No.</th>
                        <th>Name</th>
                        <th>Invoice Date</th>
                        <th>Amount</th>
                        <th>Qty</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {invoiceData.map((row, key) => {
                        return (
                          <tr key={key}>
                            <td>{(key + 1)}</td>
                            <td>{row.prefix ? row.prefix + "/" : ""}{row.invoice_no}</td>
                            <td>{row.party ? row.party.name : ""}</td>
                            <td>{row.date}</td>
                            <td>{row.total_amount}</td>
                            <td>{row.total_qty}</td>
                            <td>
                            <Link
                                to={"/invoice/dispatch/" + row.id}
                                className="btn btn-sm btn-warning mr-2 text-white"
                              >
                                Dispatch
                              </Link>
                             <Link
                                to={"/invoice/estimate/" + row.id}
                                className="btn btn-sm btn-info mr-2 text-white"
                              >
                                Estimate
                              </Link>
                              { (row.status === "Completed") && (
                                <Link
                                  to={"/invoice/view/" + row.id}
                                  className="btn btn-sm btn-success mr-2 text-white">
                                  Print
                                </Link>
                              )}
                              <Link
                                to={"/sales/invoices/edit/" + row.id}
                                className="btn btn-sm btn-secondary mr-2"
                              >
                                Edit
                              </Link>
                              { (row.status === "In Progress") ? (
                                <button
                                  onClick={() => deleteInvoice(row)}
                                  className="btn btn-sm btn-danger"
                                >
                                  Delete
                                </button>
                              ) : (
                                <button
                                  onClick={() => deleteInvoice(row)}
                                  className="btn btn-sm btn-danger"
                                >
                                  Delete
                                </button>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  {totalPages > 1 && (
                    <div className="d-flex justify-content-center my-3">
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Invoices;
